<button
    class="cerrix-btn"
    [class]="buttonClass"
    [class.success]="showResultText"
    [disabled]="disabled"
>
    @if (!waitingOnResult && !showResultText) {
        <span class="button-text">
            <ng-content></ng-content>
            <ng-content select="[button-text]"></ng-content>
        </span>
    }

    <div class="button-loader" [class.d-none]="!waitingOnResult"></div>

    @if (showResultText) {
        <span class="button-text">
            <ng-content select="[result-text]"></ng-content>
        </span>
    }
</button>
